import * as React from "react";
import "./styles.scss";
import JetpackLoader from "./JetpackLoader/JetpackLoader";

interface Props {
  loading: boolean;
  children: object;
}

export const LoadingWrapper = (props: Props) => {
  const { loading, children } = props;
  return (
    <>
      {loading && <JetpackLoader loading={true} isFullScreen={false} />}
      {children}
    </>
  );
};
